import {
  GET_LABEL_STYLES,
  GET_LINK_STYLES,
  LinkProps,
} from '@/components/Common/Nav/Link/Link.utils';
import { useGlobalContext } from '@/context/Global/GlobalContext';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom';

export default function Link({
  to,
  icon,
  label,
  collapse = false,
  horizontal = false,
  ...rest
}: LinkProps) {
  const { setSideMenuOpened } = useGlobalContext();

  return (
    <NavLink
      onClick={() => setSideMenuOpened?.(false)}
      to={to}
      style={{ position: 'relative', ...GET_LINK_STYLES(horizontal) }}
      {...rest}
    >
      {icon}
      {!collapse ? (
        <Box component="span" sx={GET_LABEL_STYLES(icon)}>
          {label}
        </Box>
      ) : null}
    </NavLink>
  );
}
